import { render } from "./BlogKitsItem.vue?vue&type=template&id=2aa7bf30&scoped=true"
import script from "./BlogKitsItem.vue?vue&type=script&lang=js"
export * from "./BlogKitsItem.vue?vue&type=script&lang=js"

import "./BlogKitsItem.vue?vue&type=style&index=0&id=2aa7bf30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa7bf30"]])

export default __exports__